(function () {
  var cache = {};

  /* One valid, representative postcode per country. Delivery here is priced by
     weight + country, never by postcode, so this lets the customer see a price
     after picking only a country. If a country is missing we ask for the code. */
  var ISO2NAME = {
    LT:'Lithuania',LV:'Latvia',EE:'Estonia',PL:'Poland',DE:'Germany',FR:'France',NL:'Netherlands',
    BE:'Belgium',LU:'Luxembourg',AT:'Austria',IT:'Italy',ES:'Spain',PT:'Portugal',IE:'Ireland',
    DK:'Denmark',SE:'Sweden',FI:'Finland',NO:'Norway',CZ:'Czechia',SK:'Slovakia',SI:'Slovenia',
    HU:'Hungary',RO:'Romania',BG:'Bulgaria',HR:'Croatia',GR:'Greece',CY:'Cyprus',MT:'Malta',
    CH:'Switzerland',LI:'Liechtenstein',IS:'Iceland',MC:'Monaco',AD:'Andorra',SM:'San Marino',
    GB:'United Kingdom',GG:'Guernsey',JE:'Jersey',IM:'Isle of Man',GI:'Gibraltar',
    US:'United States',CA:'Canada',MX:'Mexico',AU:'Australia',NZ:'New Zealand',
    JP:'Japan',KR:'South Korea',SG:'Singapore',HK:'Hong Kong SAR',CN:'China',TW:'Taiwan',
    IN:'India',IL:'Israel',TR:'Turkey',AE:'United Arab Emirates',SA:'Saudi Arabia',
    ZA:'South Africa',BR:'Brazil',AR:'Argentina',CL:'Chile',UA:'Ukraine',RS:'Serbia',
    MK:'North Macedonia',AL:'Albania',ME:'Montenegro',MD:'Moldova',GE:'Georgia',AM:'Armenia',
    KZ:'Kazakhstan',TH:'Thailand',MY:'Malaysia',ID:'Indonesia',PH:'Philippines',VN:'Vietnam',
    FO:'Faroe Islands',GL:'Greenland',AX:'Aland Islands'
  };

  /* Where a country has regions, pair the representative postcode with the
     region it actually belongs to, otherwise Shopify rejects the pair. */
  var PROV = {
    'United States':'New York','Canada':'Ontario','Australia':'New South Wales',
    'Brazil':'S\u00e3o Paulo','Mexico':'Ciudad de M\u00e9xico','Japan':'Tokyo',
    'India':'Delhi','China':'Beijing','Argentina':'Ciudad Aut\u00f3noma de Buenos Aires',
    'Italy':'Roma','Spain':'Madrid','Ireland':'Dublin','Portugal':'Lisboa',
    'Thailand':'Bangkok','Malaysia':'Kuala Lumpur','Indonesia':'Jakarta Raya',
    'New Zealand':'Wellington','South Africa':'Gauteng','Turkey':'Ankara',
    'United Arab Emirates':'Dubai','Egypt':'Cairo','Nigeria':'Lagos','Peru':'Lima',
    'Colombia':'Bogot\u00e1, D.C.','Chile':'Regi\u00f3n Metropolitana de Santiago'
  };

  var ZIP = {
    'Lithuania':'01100','Latvia':'LV-1050','Estonia':'10111','Poland':'00-001','Germany':'10115',
    'France':'75001','Netherlands':'1011 AB','Belgium':'1000','Luxembourg':'1111','Austria':'1010',
    'Italy':'00118','Spain':'28001','Portugal':'1000-001','Ireland':'D01 F5P2','Denmark':'1050',
    'Sweden':'111 20','Finland':'00100','Norway':'0010','Czechia':'110 00','Czech Republic':'110 00',
    'Slovakia':'811 01','Slovenia':'1000','Hungary':'1011','Romania':'010011','Bulgaria':'1000',
    'Croatia':'10000','Greece':'104 31','Cyprus':'1010','Malta':'VLT 1111','Switzerland':'8001',
    'Liechtenstein':'9490','Iceland':'101','Monaco':'98000','Andorra':'AD500','San Marino':'47890',
    'United Kingdom':'SW1A 1AA','Guernsey':'GY1 1AA','Jersey':'JE1 1AA','Isle of Man':'IM1 1AA','Gibraltar':'GX11 1AA',
    'United States':'10001','Canada':'M5H 2N2','Mexico':'01000',
    'Australia':'2000','New Zealand':'6011',
    'Japan':'100-0001','South Korea':'04524','Korea, South':'04524','Singapore':'018956','Hong Kong SAR':'999077',
    'China':'100000','Taiwan':'100','India':'110001','Israel':'9103401','Turkey':'06010',
    'United Arab Emirates':'00000','Saudi Arabia':'11564','Qatar':'00000','Kuwait':'13001',
    'South Africa':'0002','Brazil':'01000-000','Argentina':'C1000','Chile':'8320000',
    'Ukraine':'01001','Serbia':'11000','Bosnia & Herzegovina':'71000','North Macedonia':'1000',
    'Albania':'1001','Montenegro':'81000','Moldova':'MD-2001','Georgia':'0105','Armenia':'0010',
    'Kazakhstan':'010000','Thailand':'10100','Malaysia':'50000','Indonesia':'10110','Philippines':'1000',
    'Vietnam':'100000','Faroe Islands':'100','Greenland':'3900','Aland Islands':'22100','\u00c5land Islands':'22100'
  };



/* generated 2026-10-31 from Shopify delivery profile (EUR, by total weight kg). Regenerate if rates change. */
  var RATES = {"lim":[1.0,2.0,4.0,6.0,8.0,10.0,14.0,18.0],"z":[[42.0,65.0,85.0,105.0,125.0,145.0,185.0,225.0,285.0],[18.0,21.0,25.0,29.0,33.0,37.0,45.0,53.0,65.0],[18.0,20.0,23.0,26.0,29.0,32.0,38.0,44.0,53.0],[19.0,21.0,25.0,29.0,33.0,37.0,45.0,53.0,65.0],[29.0,38.0,45.0,52.0,59.0,66.0,80.0,94.0,115.0],[20.0,28.0,35.0,42.0,49.0,56.0,70.0,84.0,105.0],[23.0,24.0,29.0,34.0,39.0,44.0,54.0,64.0,79.0],[23.0,27.0,33.0,39.0,45.0,51.0,63.0,75.0,93.0],[15.0,21.0,26.0,31.0,36.0,41.0,51.0,61.0,76.0],[50.0,70.0,100.0,130.0,160.0,190.0,250.0,310.0,400.0],[22.0,24.0,29.0,34.0,39.0,44.0,54.0,64.0,79.0],[8.0,9.0,11.0,13.0,15.0,17.0,21.0,25.0,31.0],[23.0,25.0,31.0,37.0,43.0,49.0,61.0,73.0,91.0],[40.0,45.0,65.0,85.0,105.0,125.0,165.0,205.0,265.0],[25.0,31.0,38.0,45.0,52.0,59.0,73.0,87.0,108.0],[19.0,23.0,27.0,31.0,35.0,39.0,47.0,55.0,67.0],[32.0,35.0,45.0,55.0,65.0,75.0,95.0,115.0,145.0],[23.0,25.0,30.0,35.0,40.0,45.0,55.0,65.0,80.0],[29.0,38.0,48.0,58.0,68.0,78.0,98.0,118.0,148.0],[6.0,7.0,9.0,11.0,13.0,15.0,19.0,23.0,29.0],[2.99,2.99,2.99,2.99,2.99,2.99,2.99,2.99,2.99],[35.0,53.0,78.0,103.0,128.0,153.0,203.0,253.0,328.0],[23.0,24.0,29.0,34.0,39.0,44.0,54.0,64.0,79.0],[17.0,20.0,24.0,28.0,32.0,36.0,44.0,52.0,64.0],[19.0,21.0,25.0,29.0,33.0,37.0,45.0,53.0,65.0],[23.0,25.0,30.0,35.0,40.0,45.0,55.0,65.0,80.0],[19.0,22.0,26.0,30.0,34.0,38.0,46.0,54.0,66.0],[21.0,23.0,27.0,31.0,35.0,39.0,47.0,55.0,67.0],[17.0,19.0,23.0,27.0,31.0,35.0,43.0,51.0,63.0],[24.0,25.0,29.0,33.0,37.0,41.0,49.0,57.0,69.0],[24.0,27.0,33.0,39.0,45.0,51.0,63.0,75.0,93.0],[28.0,42.0,57.0,72.0,87.0,102.0,132.0,162.0,207.0]],"i":{"AU":0,"AT":1,"BE":2,"BG":3,"CA":4,"CN":5,"DK":6,"AD":7,"AL":7,"AX":7,"BA":7,"BY":7,"FO":7,"GG":7,"GI":7,"IM":7,"IS":7,"JE":7,"LI":7,"MC":7,"MD":7,"ME":7,"MK":7,"RS":7,"RU":7,"SJ":7,"SM":7,"UA":7,"VA":7,"XK":7,"CY":8,"CZ":8,"EE":8,"FI":8,"HR":8,"HU":8,"LU":8,"MT":8,"RO":8,"SI":8,"SK":8,"AF":9,"DZ":9,"AO":9,"AI":9,"AG":9,"AR":9,"AM":9,"AW":9,"AC":9,"AZ":9,"BS":9,"BH":9,"BD":9,"BB":9,"BZ":9,"BJ":9,"BM":9,"BT":9,"BO":9,"BW":9,"BR":9,"IO":9,"BN":9,"BF":9,"BI":9,"KH":9,"CV":9,"BQ":9,"KY":9,"CF":9,"TD":9,"CL":9,"CX":9,"CC":9,"CO":9,"KM":9,"CG":9,"CD":9,"CK":9,"CR":9,"CW":9,"CI":9,"DJ":9,"DM":9,"DO":9,"EC":9,"EG":9,"SV":9,"GQ":9,"ER":9,"SZ":9,"ET":9,"FK":9,"FJ":9,"GF":9,"PF":9,"TF":9,"GA":9,"GM":9,"GE":9,"GH":9,"GL":9,"GD":9,"GP":9,"GT":9,"GN":9,"GW":9,"GY":9,"HT":9,"HN":9,"ID":9,"IQ":9,"JM":9,"JO":9,"KZ":9,"KE":9,"KI":9,"KW":9,"KG":9,"LA":9,"LB":9,"LS":9,"LR":9,"LY":9,"MO":9,"MG":9,"MW":9,"MY":9,"MV":9,"ML":9,"MQ":9,"MR":9,"MU":9,"YT":9,"MX":9,"MN":9,"MS":9,"MA":9,"MZ":9,"MM":9,"NA":9,"NR":9,"NP":9,"NC":9,"NI":9,"NE":9,"NG":9,"NU":9,"NF":9,"OM":9,"PK":9,"PS":9,"PA":9,"PG":9,"PY":9,"PE":9,"PH":9,"PN":9,"QA":9,"CM":9,"RE":9,"RW":9,"BL":9,"SH":9,"KN":9,"LC":9,"MF":9,"PM":9,"WS":9,"ST":9,"SA":9,"SN":9,"SC":9,"SL":9,"SG":9,"SX":9,"SB":9,"SO":9,"ZA":9,"GS":9,"KR":9,"SS":9,"LK":9,"VC":9,"SD":9,"SR":9,"TW":9,"TJ":9,"TZ":9,"TH":9,"TL":9,"TG":9,"TK":9,"TO":9,"TT":9,"TA":9,"TN":9,"TM":9,"TC":9,"TV":9,"UG":9,"AE":9,"UM":9,"UY":9,"UZ":9,"VU":9,"VE":9,"VN":9,"VG":9,"WF":9,"EH":9,"YE":9,"ZM":9,"ZW":9,"FR":10,"DE":11,"GR":12,"HK":13,"IN":14,"IE":15,"IL":16,"IT":17,"JP":18,"LV":19,"LT":20,"NZ":21,"NO":22,"PL":23,"PT":24,"ES":25,"SE":26,"CH":27,"NL":28,"TR":29,"GB":30,"US":31},"n":{"Australia":"AU","Austria":"AT","Belgium":"BE","Bulgaria":"BG","Canada":"CA","China":"CN","Denmark":"DK","Andorra":"AD","Albania":"AL","Aland Islands":"AX","Bosnia And Herzegovina":"BA","Belarus":"BY","Faroe Islands":"FO","Guernsey":"GG","Gibraltar":"GI","Isle Of Man":"IM","Iceland":"IS","Jersey":"JE","Liechtenstein":"LI","Monaco":"MC","Moldova, Republic of":"MD","Montenegro":"ME","North Macedonia":"MK","Serbia":"RS","Russia":"RU","Svalbard And Jan Mayen":"SJ","San Marino":"SM","Ukraine":"UA","Holy See (Vatican City State)":"VA","Kosovo":"XK","Cyprus":"CY","Czech Republic":"CZ","Estonia":"EE","Finland":"FI","Croatia":"HR","Hungary":"HU","Luxembourg":"LU","Malta":"MT","Romania":"RO","Slovenia":"SI","Slovakia":"SK","Afghanistan":"AF","Algeria":"DZ","Angola":"AO","Anguilla":"AI","Antigua And Barbuda":"AG","Argentina":"AR","Armenia":"AM","Aruba":"AW","Ascension Island":"AC","Azerbaijan":"AZ","Bahamas":"BS","Bahrain":"BH","Bangladesh":"BD","Barbados":"BB","Belize":"BZ","Benin":"BJ","Bermuda":"BM","Bhutan":"BT","Bolivia":"BO","Botswana":"BW","Brazil":"BR","British Indian Ocean Territory":"IO","Brunei":"BN","Burkina Faso":"BF","Burundi":"BI","Cambodia":"KH","Cape Verde":"CV","Caribbean Netherlands":"BQ","Cayman Islands":"KY","Central African Republic":"CF","Chad":"TD","Chile":"CL","Christmas Island":"CX","Cocos (Keeling) Islands":"CC","Colombia":"CO","Comoros":"KM","Congo":"CG","Congo, The Democratic Republic Of The":"CD","Cook Islands":"CK","Costa Rica":"CR","Curaçao":"CW","Côte d'Ivoire":"CI","Djibouti":"DJ","Dominica":"DM","Dominican Republic":"DO","Ecuador":"EC","Egypt":"EG","El Salvador":"SV","Equatorial Guinea":"GQ","Eritrea":"ER","Eswatini":"SZ","Ethiopia":"ET","Falkland Islands (Malvinas)":"FK","Fiji":"FJ","French Guiana":"GF","French Polynesia":"PF","French Southern Territories":"TF","Gabon":"GA","Gambia":"GM","Georgia":"GE","Ghana":"GH","Greenland":"GL","Grenada":"GD","Guadeloupe":"GP","Guatemala":"GT","Guinea":"GN","Guinea Bissau":"GW","Guyana":"GY","Haiti":"HT","Honduras":"HN","Indonesia":"ID","Iraq":"IQ","Jamaica":"JM","Jordan":"JO","Kazakhstan":"KZ","Kenya":"KE","Kiribati":"KI","Kuwait":"KW","Kyrgyzstan":"KG","Lao People's Democratic Republic":"LA","Lebanon":"LB","Lesotho":"LS","Liberia":"LR","Libyan Arab Jamahiriya":"LY","Macao":"MO","Madagascar":"MG","Malawi":"MW","Malaysia":"MY","Maldives":"MV","Mali":"ML","Martinique":"MQ","Mauritania":"MR","Mauritius":"MU","Mayotte":"YT","Mexico":"MX","Mongolia":"MN","Montserrat":"MS","Morocco":"MA","Mozambique":"MZ","Myanmar":"MM","Namibia":"NA","Nauru":"NR","Nepal":"NP","New Caledonia":"NC","Nicaragua":"NI","Niger":"NE","Nigeria":"NG","Niue":"NU","Norfolk Island":"NF","Oman":"OM","Pakistan":"PK","Palestinian Territory, Occupied":"PS","Panama":"PA","Papua New Guinea":"PG","Paraguay":"PY","Peru":"PE","Philippines":"PH","Pitcairn":"PN","Qatar":"QA","Republic of Cameroon":"CM","Reunion":"RE","Rwanda":"RW","Saint Barthélemy":"BL","Saint Helena":"SH","Saint Kitts And Nevis":"KN","Saint Lucia":"LC","Saint Martin":"MF","Saint Pierre And Miquelon":"PM","Samoa":"WS","Sao Tome And Principe":"ST","Saudi Arabia":"SA","Senegal":"SN","Seychelles":"SC","Sierra Leone":"SL","Singapore":"SG","Sint Maarten":"SX","Solomon Islands":"SB","Somalia":"SO","South Africa":"ZA","South Georgia And The South Sandwich Islands":"GS","South Korea":"KR","South Sudan":"SS","Sri Lanka":"LK","St. Vincent":"VC","Sudan":"SD","Suriname":"SR","Taiwan":"TW","Tajikistan":"TJ","Tanzania, United Republic Of":"TZ","Thailand":"TH","Timor Leste":"TL","Togo":"TG","Tokelau":"TK","Tonga":"TO","Trinidad and Tobago":"TT","Tristan da Cunha":"TA","Tunisia":"TN","Turkmenistan":"TM","Turks and Caicos Islands":"TC","Tuvalu":"TV","Uganda":"UG","United Arab Emirates":"AE","United States Minor Outlying Islands":"UM","Uruguay":"UY","Uzbekistan":"UZ","Vanuatu":"VU","Venezuela":"VE","Vietnam":"VN","Virgin Islands, British":"VG","Wallis And Futuna":"WF","Western Sahara":"EH","Yemen":"YE","Zambia":"ZM","Zimbabwe":"ZW","France":"FR","Germany":"DE","Greece":"GR","Hong Kong":"HK","India":"IN","Ireland":"IE","Israel":"IL","Italy":"IT","Japan":"JP","Latvia":"LV","Lithuania":"LT","New Zealand":"NZ","Norway":"NO","Poland":"PL","Portugal":"PT","Spain":"ES","Sweden":"SE","Switzerland":"CH","Netherlands":"NL","Turkey":"TR","United Kingdom":"GB","United States":"US"}};

  function normName(v) { return String(v || '').toLowerCase().replace(/&/g, 'and').replace(/\b(sar|china|republic of|the)\b/g, '').replace(/[^a-z]/g, ''); }
  var NAME2ISO = null;
  function isoOf(name) {
    if (RATES.n[name]) return RATES.n[name];
    if (!NAME2ISO) {
      NAME2ISO = {};
      Object.keys(RATES.n).forEach(function (k) { NAME2ISO[normName(k)] = RATES.n[k]; });
      Object.keys(ISO2NAME).forEach(function (k) { NAME2ISO[normName(ISO2NAME[k])] = k; });
      try {
        var dn = new Intl.DisplayNames(['en'], { type: 'region' });
        Object.keys(RATES.i).forEach(function (k) { if (k !== '*') { var n = dn.of(k); if (n) NAME2ISO[normName(n)] = NAME2ISO[normName(n)] || k; } });
      } catch (e) {}
    }
    return NAME2ISO[normName(name)] || '';
  }
  function nameOf(iso) { return iso ? (ISO2NAME[iso] || '') : ''; }

  /* Transit time by destination — matches the published delivery policy.
     Shopify's own rates carry one uniform transit time, which was showing
     "3-5 business days" for every country. */
  var DAYS_BALTIC = ['Lithuania','Latvia'];
  var DAYS_EU = ['Austria','Belgium','Bulgaria','Croatia','Cyprus','Czechia','Czech Republic','Denmark',
    'Estonia','Finland','France','Germany','Greece','Hungary','Ireland','Italy','Luxembourg','Malta',
    'Netherlands','Poland','Portugal','Romania','Slovakia','Slovenia','Spain','Sweden',
    'Norway','Switzerland','Iceland','Liechtenstein','Monaco','Andorra','San Marino','Vatican City',
    'Aland Islands','\u00c5land Islands','Faroe Islands','Gibraltar','Guernsey','Jersey','Isle of Man'];
  var DAYS_5_7 = ['United Kingdom','United States'];
  var DAYS_5_8 = ['Canada'];
  var DAYS_FAR = ['Australia','New Zealand'];

  function transitFor(country) {
    if (DAYS_BALTIC.indexOf(country) > -1) return [1, 3];
    if (DAYS_EU.indexOf(country) > -1) return [3, 5];
    if (DAYS_5_7.indexOf(country) > -1) return [5, 7];
    if (DAYS_5_8.indexOf(country) > -1) return [5, 8];
    if (DAYS_FAR.indexOf(country) > -1) return [8, 12];
    return [7, 10];
  }

  function money(cents, currency) {
    var mf = document.querySelector('[data-mfmt]'), sm = mf && mf.getAttribute('data-mfmt'), mm = sm && sm.match(/1(\D?)234(\D)56/);
    if (mm && (!currency || !window.Shopify || !Shopify.currency || currency === Shopify.currency.active)) {
      var n = (Math.abs(cents) / 100).toFixed(2).split('.');
      n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, mm[1]);
      return (cents < 0 ? '-' : '') + sm.replace(mm[0], n[0] + mm[2] + n[1]);
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }

  function T(box, key, fallback) {
    var v = box.getAttribute('data-t-' + key);
    return (v === null || v === '') ? fallback : v;
  }

  function out(box, html) {
    var el = box.querySelector('[data-nw-cartship-out]');
    if (el) el.innerHTML = html;
  }

  /* Summary rows: delivery price next to the country, grand total below. */
  function setShip(box, cents, currency) {
    var pe = box.querySelector('[data-nw-ship-price]');
    var g = document.querySelector('[data-nw-grand]');
    var total = parseInt(box.getAttribute('data-cart-total') || '0', 10);
    var priced = typeof cents === 'number';
    if (pe) pe.textContent = priced ? (cents === 0 ? T(box, 'free', 'Free') : money(cents, currency)) : '—';
    if (g) {
      var gv = g.querySelector('[data-nw-grand-v]');
      if (gv) gv.textContent = money(total + (priced ? cents : 0), currency);
      g.classList.toggle('is-partial', !priced);
    }
    document.documentElement.classList.toggle('nw-ship-priced', priced);
  }

  function provincesFor(opt) {
    if (!opt) return [];
    try { return JSON.parse(opt.getAttribute('data-provinces') || '[]'); } catch (e) { return []; }
  }

  function syncProvinces(box) {
    var c = box.querySelector('[data-nw-c]');
    var p = box.querySelector('[data-nw-p]');
    if (!c || !p) return;
    var list = provincesFor(c.options[c.selectedIndex]);
    if (!list.length) { p.hidden = true; p.innerHTML = ''; return; }
    p.hidden = true;
    p.innerHTML = '<option value="">' + T(box, 'regionopt', 'Region') + '</option>' +
      list.map(function (x) { return '<option value="' + x[0] + '">' + x[0] + '</option>'; }).join('');
  }

  function estimate(box) {
    var c = box.querySelector('[data-nw-c]');
    var p = box.querySelector('[data-nw-p]');
    var z = box.querySelector('[data-nw-z]');
    if (!c || !c.value) return;
    var country = c.value;
    var zip = (z && z.value.trim()) || '';
    var prov = (p && !p.hidden && p.value) || '';
    /* Prices depend on weight + country, never on the region, so if the buyer
       has not picked one we quietly use the first region on the list. */
    if (!prov && p && !p.hidden) {
      var pl = provincesFor(c.options[c.selectedIndex]);
      var want = PROV[country];
      var found = '';
      for (var pi = 0; pi < pl.length; pi++) {
        if (want && (pl[pi][0] === want || pl[pi][1] === want)) { found = pl[pi][0]; break; }
      }
      prov = found || (pl.length ? pl[0][0] : '');
    }
    var total = parseInt(box.getAttribute('data-cart-total') || '0', 10);

    /* 2026-10-31: price is computed here from the delivery-rate table (weight + country).
       We no longer call /cart/shipping_rates.json with a sample postcode: Shopify stored
       that postcode on the cart and pre-filled it at checkout (e.g. "01100"). */
    if (p) p.hidden = true;
    if (z) z.hidden = true;
    var kg = parseInt(box.getAttribute('data-cart-weight') || '0', 10) / 1000;
    var iso = isoOf(country);
    var zi = (iso && RATES.i[iso] != null) ? RATES.i[iso] : RATES.i['*'];
    if (zi == null) {
      setShip(box, null);
      out(box, '<span class="nw-cartship__hint">' + T(box, 'atcheckout', 'You will see the exact delivery price at checkout.') + '</span>');
      return;
    }
    var t = 0;
    while (t < RATES.lim.length && kg > RATES.lim[t] + 0.0001) t++;
    var eur = RATES.z[zi][t];
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
    var cents = Math.round(eur * rate * 100);
    var tr = transitFor(nameOf(iso) || country);
    var days = (tr[0] === tr[1])
      ? tr[0] + ' ' + T(box, 'days', 'business days')
      : tr[0] + '\u2013' + tr[1] + ' ' + T(box, 'days', 'business days');
    setShip(box, cents, cur);
    out(box, '<span class="nw-cartship__days">' + T(box, 'dtime', 'Delivery time') + ' ' + days + '</span>');
  }

  function debounce(fn, ms) {
    var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  function init(box) {
    if (!box || box.dataset.nwBound) return;
    box.dataset.nwBound = '1';
    var c = box.querySelector('[data-nw-c]');
    var here = box.getAttribute('data-here');
    var hereIso = (box.getAttribute('data-here-iso') || '').toUpperCase();
    var wanted = ISO2NAME[hereIso] || here;
    /* keep the country the buyer picked by hand when the cart re-renders (discount, quantity) */
    try { var saved = sessionStorage.getItem('nw-ship-country'); if (saved) wanted = saved; } catch (e) {}
    if (c && wanted) {
      var hit = -1;
      for (var i = 0; i < c.options.length; i++) {
        if (c.options[i].value === wanted || c.options[i].value === here) { hit = i; break; }
      }
      if (hit > -1) c.selectedIndex = hit;
    }
    syncProvinces(box);
    var run = debounce(function () { estimate(box); }, 450);
    if (c) c.addEventListener('change', function () {
      try { sessionStorage.setItem('nw-ship-country', c.value); } catch (e) {}
      syncProvinces(box);
      var zz = box.querySelector('[data-nw-z]');
      if (zz) { zz.value = ''; zz.hidden = true; }
      estimate(box);
    });
    var p = box.querySelector('[data-nw-p]');
    if (p) p.addEventListener('change', function () { estimate(box); });
    var z = box.querySelector('[data-nw-z]');
    if (z) z.addEventListener('input', run);
    estimate(box);
  }

  function scan() { document.querySelectorAll('[data-nw-cartship]').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();


/* --- Product description: strip decorative emoji, then give the copy structure --- */
(function () {
  /* Antrasciu atpazinimas turi veikti ABIEM kalbom. Anksciau buvo tik angliski
     raktazodziai, todel LT parduotuveje "Matmenys" negaudavo data-icon="rule",
     liftSpecs() lenteles nerasdavo ir ji likdavo aprasyme (o ne virs "Naudinga zinoti"),
     o "Prekes kodas (SKU)" nebudavo paslepiamas, nors jis jau rodomas po kaina. */
  var NW_DIM_RE  = /dimension|size|measure|matmen|dydzi|dydži|ismatav|išmatav|maße|masse|abmessung|größe/i;
  var NW_CARE_RE = /care|clean|wash|prieziur|priežiūr|valym|pflege|reinig/i;
  var NW_MAT_RE  = /material|willow|weave|medziag|medžiag|vytel|pynim|weide|geflecht/i;
  var NW_SKU_RE  = /^\s*(product code|prekes kodas|prekės kodas|artikelnummer|sku)\b/i;

  var EMOJI = /[\u{1F300}-\u{1FAFF}\u{1F1E6}-\u{1F1FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{FE0F}\u{200D}\u{20E3}]/gu;

  function clean(root) {
    if (!root || root.dataset.nwCleaned) return;
    root.dataset.nwCleaned = '1';
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n, nodes = [];
    while ((n = w.nextNode())) nodes.push(n);
    /* 2026-10-07: Lukas nori, kad emoji aprasymuose butu matomi - nebetrinam. */
    if (false) nodes.forEach(function (t) {
      var v = t.nodeValue.replace(EMOJI, '');
      if (v !== t.nodeValue) t.nodeValue = v.replace(/[ \t]{2,}/g, ' ').replace(/^\s+(?=\S)/, '');
    });
    root.querySelectorAll('p, div').forEach(function (p) {
      var s = p.textContent.replace(/\s+/g, ' ').trim();
      if (NW_SKU_RE.test(s)) { p.style.display = 'none'; return; }
      if (!s && !p.querySelector('img, iframe, table, ul, ol')) p.style.display = 'none';
    });
  }

  function mkSpec(lines) {
    var dl = document.createElement('dl');
    dl.className = 'nw-spec';
    lines.forEach(function (l) {
      var dt = document.createElement('dt');
      var dd = document.createElement('dd');
      if (isGroupLine(l)) { dt.className = 'nw-spec__group'; dd.className = 'nw-spec__group-dd'; dt.textContent = l.replace(/:\s*$/, ''); dl.appendChild(dt); dl.appendChild(dd); return; }
      var t = l.replace(/^[–—-]\s*/, '');
      var i = t.indexOf(':');
      if (i > 0) { dt.textContent = t.slice(0, i).trim(); dd.textContent = t.slice(i + 1).trim(); }
      else { dt.textContent = t; }
      dl.appendChild(dt); dl.appendChild(dd);
    });
    return dl;
  }

  function isSpecLine(l) { return /^[–—-]/.test(l); }
  /* 2026-10-29: size-group headers inside dimensions ("Mažoji:", "Small:", "Groß:") */
  function isGroupLine(l) { return !/^[–—-]/.test(l) && /:\s*$/.test(l) && l.length <= 40; }
  function isSpecBlock(lines) { return lines.length >= 2 && lines.some(isSpecLine) && lines.every(function (l) { return isSpecLine(l) || isGroupLine(l); }); }

  function structure(root) {
    if (!root || root.dataset.nwStructured) return;
    root.dataset.nwStructured = '1';

    Array.prototype.slice.call(root.querySelectorAll('p')).forEach(function (p) {
      if (p.style.display === 'none') return;
      var st = p.firstElementChild;
      if (!st || st.tagName !== 'STRONG') return;

      var head = st.textContent.replace(/\s+/g, ' ').replace(/[:\s]+$/, '').trim();
      if (!head || head.length > 46) return;
      if (NW_SKU_RE.test(head)) { p.style.display = 'none'; return; }

      var parts = p.innerHTML.split(/<br\s*\/?>/i);
      var rest = parts.slice(1).map(function (x) { return x.replace(/\s+/g, ' ').trim(); })
        .filter(function (x) { return x.replace(/<[^>]+>/g, '').trim(); });
      var plain = rest.map(function (x) { return x.replace(/<[^>]+>/g, '').trim(); });

      var frag = document.createDocumentFragment();
      var h = document.createElement('h3');
      h.className = 'nw-pinfo__sub';
      h.textContent = head;
      var key = head.toLowerCase();
      if (NW_DIM_RE.test(key)) h.setAttribute('data-icon', 'rule');
      else if (NW_CARE_RE.test(key)) h.setAttribute('data-icon', 'care');
      else if (NW_MAT_RE.test(key)) h.setAttribute('data-icon', 'weave');
      else h.setAttribute('data-icon', 'dot');
      frag.appendChild(h);

      if (isSpecBlock(plain)) {
        frag.appendChild(mkSpec(plain));
      } else if (rest.length) {
        var np = document.createElement('p');
        np.innerHTML = rest.join('<br>');
        frag.appendChild(np);
      }
      p.replaceWith(frag);
    });

    Array.prototype.slice.call(root.querySelectorAll('p')).forEach(function (p) {
      if (p.style.display === 'none' || !p.querySelector('br')) return;
      var lines = p.innerHTML.split(/<br\s*\/?>/i)
        .map(function (x) { return x.replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim(); })
        .filter(Boolean);
      if (isSpecBlock(lines)) p.replaceWith(mkSpec(lines));
    });

    var first = root.querySelector('p');
    if (first && first.style.display !== 'none') first.classList.add('nw-pinfo__lead');

    root.querySelectorAll('p').forEach(function (p) {
      var em = p.querySelector('em');
      if (em && p.textContent.replace(/\s+/g, ' ').trim() === em.textContent.replace(/\s+/g, ' ').trim()) {
        p.classList.add('nw-pinfo__note');
      }
    });
  }

  // Move the dimensions table into the right column so the aside is not a tall empty gap
  function liftSpecs() {
    var side = document.querySelector('.nw-pinfo__side');
    var rte = document.querySelector('.nw-pinfo__rte');
    if (!side || !rte || side.dataset.nwLifted) return;

    var head = rte.querySelector('.nw-pinfo__sub[data-icon="rule"]');
    var table = head && head.nextElementSibling;
    if (!head || !table || !table.classList.contains('nw-spec')) return;

    side.dataset.nwLifted = '1';
    var card = document.createElement('div');
    card.className = 'nw-pinfo__speccard';
    var t = document.createElement('p');
    t.className = 'nw-pinfo__spechead';
    t.textContent = head.textContent;
    card.appendChild(t);
    card.appendChild(table);
    head.remove();

    // the handmade-variation note belongs with the measurements, small
    var note = rte.querySelector('.nw-pinfo__note');
    if (note) { note.classList.add('nw-pinfo__note--tight'); card.appendChild(note); }

    side.insertBefore(card, side.firstChild);
  }

  // Care belongs beside the specs — but only the sentences that are actually about care.
  // Anything else that sat under the old "Care" heading goes back into the description.
  var CARE_RE = /\b(dry|damp|cloth|wipe|water|mist|brittle|radiator|humid|sunlight|clean|dust|store it|storing|soak)\b/i;

  function liftCare() {
    var side = document.querySelector('.nw-pinfo__side');
    var rte = document.querySelector('.nw-pinfo__rte');
    if (!side || !rte || side.dataset.nwCare) return;

    var head = rte.querySelector('.nw-pinfo__sub[data-icon="care"]');
    if (!head) return;

    var block = [];
    var n = head.nextElementSibling;
    while (n && !n.classList.contains('nw-pinfo__sub')) {
      block.push(n);
      n = n.nextElementSibling;
    }
    if (!block.length) return;

    var careBits = block.filter(function (el) { return CARE_RE.test(el.textContent); });
    var rest = block.filter(function (el) { return careBits.indexOf(el) === -1; });
    if (!careBits.length) { careBits = [block[0]]; rest = block.slice(1); }

    side.dataset.nwCare = '1';

    var card = document.createElement('div');
    card.className = 'nw-pinfo__carecard';
    var t = document.createElement('p');
    t.className = 'nw-pinfo__carehead';
    t.textContent = head.textContent;
    card.appendChild(t);
    careBits.forEach(function (el) { card.appendChild(el); });

    // leftovers keep their original place in the description — no reshuffling
    head.remove();

    var spec = side.querySelector('.nw-pinfo__speccard');
    if (spec && spec.nextSibling) side.insertBefore(card, spec.nextSibling);
    else if (spec) side.appendChild(card);
    else side.insertBefore(card, side.firstChild);
  }

  // Long copy stays in the page for search engines, but folds away on a phone
  function collapseCopy() {
    var rte = document.querySelector('.nw-pinfo__rte');
    if (!rte || rte.dataset.nwFold) return;
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    if (rte.scrollHeight < 340) return;

    rte.dataset.nwFold = '1';
    rte.classList.add('nw-pinfo__rte--folded');

    // Mygtuko tekstas ateina is sekcijos (isverciamas), o ne is JS.
    var grid = document.querySelector('.nw-pinfo__grid');
    var LBL_MORE = (grid && grid.getAttribute('data-nw-more')) || 'Read more';
    var LBL_LESS = (grid && grid.getAttribute('data-nw-less')) || 'Show less';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'nw-pinfo__more';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = LBL_MORE;
    btn.addEventListener('click', function () {
      var open = rte.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? LBL_LESS : LBL_MORE;
      if (!open) rte.scrollIntoView({ block: 'start' });
    });
    rte.parentNode.insertBefore(btn, rte.nextSibling);
  }

  function run() {
    document.querySelectorAll('.product-details rte-formatter, .nw-pinfo__rte').forEach(clean);
    document.querySelectorAll('.nw-pinfo__rte').forEach(structure);
    liftSpecs();
    liftCare();
    collapseCopy();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
})();

/* --- Process steps: let the photo turn into a short loop when it is on screen --- */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var conn = navigator.connection;
  if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ''))) return;

  function setup() {
    document.querySelectorAll('video[data-nw-clip]').forEach(function (v) {
      if (v.dataset.nwReady) return;
      v.dataset.nwReady = '1';
      var box = v.parentElement;
      box.classList.add('has-clip');

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            if (!v.src) { v.src = v.dataset.src; v.load(); }
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
            v.addEventListener('playing', function () { box.classList.add('is-playing'); }, { once: true });
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.45 });
      io.observe(box);
    });
  }

  if (document.readyState === 'complete') setup();
  else window.addEventListener('load', setup, { once: true });
  new MutationObserver(setup).observe(document.documentElement, { childList: true, subtree: true });
})();

/* --- Reviews: make the rating in the buy box jump to this product's reviews --- */
(function () {
  function wire() {
    var widget = document.querySelector('.jdgm-rev-widg, .jdgm-widget-product-reviews, [id*="judgeme_product_reviews"]');
    if (!widget) return;

    // a real anchor target, so the jump works even if scripted scrolling is blocked
    if (!document.getElementById('reviews')) {
      var a = document.createElement('span');
      a.id = 'reviews';
      a.style.display = 'block';
      a.style.scrollMarginTop = '90px';
      widget.parentNode.insertBefore(a, widget);
    }

    document.querySelectorAll('.rating-count').forEach(function (el) {
      if (el.dataset.nwLinked) return;
      el.dataset.nwLinked = '1';
      var link = document.createElement('a');
      link.href = '#reviews';
      link.className = 'nw-ratinglink';
      var lg = (document.documentElement.lang || 'en').slice(0, 2); link.title = lg === 'de' ? 'Bewertungen zu diesem Artikel lesen' : lg === 'lt' ? 'Skaityti atsiliepimus apie šį gaminį' : 'Read the reviews for this basket';
      while (el.firstChild) link.appendChild(el.firstChild);
      el.appendChild(link);
    });
  }

  if (document.readyState === 'complete') wire();
  else window.addEventListener('load', wire, { once: true });
  new MutationObserver(wire).observe(document.documentElement, { childList: true, subtree: true });
})();

/* --- Reviews carousel: make it obvious that more reviews exist --- */
(function () {
  function hint() {
    document.querySelectorAll('.jdgm-cards-carousel').forEach(function (c) {
      if (c.dataset.nwHint) return;
      c.dataset.nwHint = '1';
      c.classList.add('nw-revcar');
    });
  }
  if (document.readyState === 'complete') hint();
  else window.addEventListener('load', hint, { once: true });
  new MutationObserver(hint).observe(document.documentElement, { childList: true, subtree: true });
})();



/* 2026-10-31: one-time cart refresh. The old delivery estimator stored a sample
   postcode (e.g. 01100) on the cart, and Shopify pre-filled it at checkout. That
   value can't be cleared on an existing cart, so we move the items into a new
   cart once per browser. */
(function () {
  var FLAG = 'nw-cart-zipfix-1';
  try { if (localStorage.getItem(FLAG)) return; } catch (e) { return; }
  function done() { try { localStorage.setItem(FLAG, '1'); } catch (e) {} }
  if (!/(?:^|; )cart=/.test(document.cookie)) { done(); return; }
  if (/\/checkouts?\//.test(location.pathname)) return;
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var J = { 'Content-Type': 'application/json', Accept: 'application/json' };
  fetch(R + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
    var items = (cart.items || []).map(function (it) {
      var o = { id: it.variant_id, quantity: it.quantity };
      if (it.properties && Object.keys(it.properties).length) o.properties = it.properties;
      if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) o.selling_plan = it.selling_plan_allocation.selling_plan.id;
      return o;
    });
    var host = location.hostname.replace(/^www\./, '');
    ['', '; domain=' + location.hostname, '; domain=.' + host].forEach(function (d) {
      document.cookie = 'cart=; path=/' + d + '; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    });
    if (!items.length) { done(); return; }
    return fetch(R + 'cart/add.js', { method: 'POST', headers: J, body: JSON.stringify({ items: items }) })
      .then(function (r) {
        if (!r.ok) return;
        var upd = {};
        if (cart.attributes && Object.keys(cart.attributes).length) upd.attributes = cart.attributes;
        if (cart.note) upd.note = cart.note;
        var p = Object.keys(upd).length ? fetch(R + 'cart/update.js', { method: 'POST', headers: J, body: JSON.stringify(upd) }) : Promise.resolve();
        return p.then(function () {
          done();
          if (/\/cart\/?$/.test(location.pathname)) location.reload();
        });
      });
  }).catch(function () {});
})();
